export default (rangeAge) => {
  const label = {
    'adults': 'Adulto',
    'children': 'Criança',
    'infants': 'Bebê'
  }

  return label[rangeAge]
}
